module.exports = __webpack_public_path__ + "static/media/techton_splash_3.6b044a45.webp";